import { render } from "./TopAccount.vue?vue&type=template&id=275ef379&scoped=true"
import script from "./TopAccount.vue?vue&type=script&lang=js"
export * from "./TopAccount.vue?vue&type=script&lang=js"

import "./TopAccount.vue?vue&type=style&index=0&id=275ef379&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275ef379"]])

export default __exports__